import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { ColumnContainer } from "routes/library/components";
import { ActivityItem } from "shared/atoms/PatientApp";

import type { LessonSubset } from "./LessonPreviewMobile";
import { LessonPreviewMobile } from "./LessonPreviewMobile";
import { ScreenSelector, type SelectedScreen } from "./ScreenSelector";

interface Props {
  image_url: string | null;
  isLoading: boolean;
  lesson: LessonSubset;
  selectedScreen: SelectedScreen;
  setSelectedScreen: React.Dispatch<React.SetStateAction<SelectedScreen>>;
}

export const PreviewColumn: React.FC<Props> = ({ image_url, isLoading, lesson, selectedScreen, setSelectedScreen }) => {
  const { t } = useTranslation();

  return (
    <StyledColumnContainer heading={t("library.exercises.form.preview_header")}>
      <MobileAndQuizContainer>
        <MobileAndCardContainer>
          <LessonPreviewMobile lesson={lesson} selectedScreen={selectedScreen} />
          <ActivityItem
            image_url={image_url}
            isLoading={isLoading}
            title={lesson?.parts[0]?.translation?.title}
            type="text_lesson"
          />
        </MobileAndCardContainer>

        <ScreenSelector
          totalQuestions={lesson?.parts?.[0]?.translation?.questions?.length || 0}
          selectedScreen={selectedScreen}
          setSelectedScreen={setSelectedScreen}
        />
      </MobileAndQuizContainer>
    </StyledColumnContainer>
  );
};

const StyledColumnContainer = styled(ColumnContainer)`
  flex: 0 1 auto;
  gap: 14px;
  max-width: 100%;

  ${({ theme }) => theme.aboveBreakpoint} {
    align-self: flex-start;
    position: sticky;
    top: 16px;
  }
`;

const MobileAndQuizContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

const MobileAndCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  max-width: 100%;
  order: 2;

  ${({ theme }) => theme.aboveBreakpoint} {
    order: 0;
  }
`;
